import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { DateRangePicker } from 'src/components/date-range'
import { Dropdown, DropdownOption } from 'src/components/dropdown'
import { FlexColumn } from 'src/components/flex-containers'
import { Colors } from 'src/components/theme'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const AcquisitionHistoryFilters = () => {
  const options: DropdownOption[] = [
    {
      label: 'All',
      value: 'all',
      id: 'all',
    },
    {
      label: 'Purchases',
      value: 'purchases',
      id: 'purchases',
    },
    {
      label: 'Sales',
      value: 'sales',
      id: 'sales',
    },
  ]
  return (
    <Wrapper>
      <FlexColumn>
        <Typography variant="text1" color={Colors.textBlack}>
          Filter
        </Typography>
        <Dropdown value={'all'} options={options} />
      </FlexColumn>

      <DateRangePicker />
    </Wrapper>
  )
}
